import StockResearch from '@/views/warehouse/StockResearch'

export default [
    { path: '/warehouse/stock/research', name: 'StockResearch',  component: StockResearch, meta: { authRequired: true,    desc: '재고조사'} },
]



// WEBPACK FOOTER //
// ./src/router/warehouse/index.js